import { FC } from 'react';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { Link, Typography } from 'melp-design/components';
import { ROUTES } from 'config';

interface Props {
  items: Array<{ label: string; url?: string }>;
}

export const Breadcrumbs: FC<Props> = ({ items }) => {
  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      {/* TODO: add translation */}
      <Link to={ROUTES.root.index} label="Home" />

      {items.map((item, i) =>
        item.url ? (
          <Link to={item.url} label={item.label} key={i} />
        ) : (
          <Typography variant="h3" color="textPrimary" key={i}>
            {item.label}
          </Typography>
        ),
      )}
    </MuiBreadcrumbs>
  );
};
